document.addEventListener('DOMContentLoaded', function() {
  // Verificar si el usuario ya ha aceptado la restricción de edad
  if (!localStorage.getItem('ageVerified')) {
    document.getElementById('ageVerification').style.display = 'flex';
  }

  // Manejar el clic en "Sí, soy mayor de edad"
  document.getElementById('confirmAge').addEventListener('click', function(e) {
    e.preventDefault();
    localStorage.setItem('ageVerified', 'true');
    document.getElementById('ageVerification').style.display = 'none';
  });

  // Opción para "No, soy menor de edad" - redirigir o tomar alguna acción
  document.querySelector('.button._2').addEventListener('click', function(e) {
    e.preventDefault();
    alert("Lamentablemente no puedes acceder a este sitio.");
    window.location.href = 'https://example.com'; // Redirigir a otra página
  });
});
